import React, { useState, useEffect } from "react";
import { FaHome, FaPlus } from "react-icons/fa";
import { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RiMenuSearchFill } from "react-icons/ri";
export default function CustomFooter() {
  const location = useLocation();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY.current) {
        setVisible(false);
      } else {
        setVisible(true);
      }
      lastScrollY.current = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <div
      className="position-fixed bottom-0 mb-1 w-100 d-flex justify-content-center transition-all"
      style={{
        zIndex: 1000,
        transform: visible ? "translateY(0)" : "translateY(100%)",
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
        transition: "transform 0.3s ease, opacity 0.3s ease",
      }}
    >
      <div
        className="position-relative shadow py-1 rounded-3 d-flex justify-content-between align-items-center"
        style={{
          width: "95%",
          backgroundColor: "rgb(20,20,20,0.95)",
        }}
      >
        <div
          className="text-center flex-fill"
          onClick={() => {
            navigate("/dashboard");
          }}
          style={{ cursor: "pointer" }}
        >
          <FaHome
            size={20}
            color={location.pathname === "/dashboard" ? "#e40e0e" : "white"}
          />
          <div
            style={{
              fontSize: "0.6rem",
              color: location.pathname === "/dashboard" ? "#e40e0e" : "white",
            }}
          >
            Home
          </div>
        </div>
        <div style={{ width: "75px" }}></div>
        <div
          className="text-center flex-fill"
          onClick={() => {
            navigate("/cashflow");
          }}
          style={{ cursor: "pointer" }}
        >
          <RiMenuSearchFill
            size={20}
            color={location.pathname === "/cashflow" ? "#e40e0e" : "white"}
          />
          <div
            style={{
              fontSize: "0.6rem",
              color: location.pathname === "/cashflow" ? "#e40e0e" : "white",
            }}
          >
            CashFlow
          </div>
        </div>

        <div
          className="position-absolute top-0 start-50 translate-middle-x shadow borde-bottom"
          style={{
            width: "68px",
            height: "35px",
            backgroundColor: "white",
            borderBottomLeftRadius: "80px",
            borderBottomRightRadius: "80px",
            zIndex: 0,
          }}
        ></div>

        <button
          className={`btn rounded-circle position-absolute top-0 start-50 translate-middle ${
            location.pathname === "/bill-add" ? "bg-white border-primary" : "btn-primary"
          }`}
          onClick={() => {
            navigate("/bill-add");
          }}
          style={{
            width: "55px",
            height: "55px",
            zIndex: 1,
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
          }}
        >
          <FaPlus size={20} color={location.pathname === "/bill-add" ? "#e40e0e" : "white"} />
        </button>
      </div>
    </div>
  );
}
